import {motion} from 'framer-motion';
import Card from "../shared/Card";
import GeneralContext from '../../context/GeneralContext';
import { useContext } from 'react';
import ButtonFunction from '../shared/ButtonFunction';
import { GiPalmTree } from "react-icons/gi";

function ManageBenefits() {

  const { changeCurrentMenu } = useContext(GeneralContext);

  return (
    <motion.div
      key='adminManageBenefits'
      initial={{opacity: 0, x: -1000}}
      animate={{opacity: 1, x: 0}}
      exit={{opacity: 0, x: -1000, transition:{duration: 0.5, delay: 0}}}
      transition={{duration: 0.5}}>
        <Card>
          <GiPalmTree size='50px'/>
          <h2>Gestionar Beneficios</h2>
          <ButtonFunction
          buttonFunction={changeCurrentMenu}
          buttonArguments={'add-benefit'}
          buttonClass='adminButton'
        >
          Agregar Beneficio
        </ButtonFunction>
        <br />
        <br />
        <ButtonFunction
          buttonFunction={changeCurrentMenu}
          buttonArguments={'benefit-list'}
          buttonClass='adminButton'
        >
          Listar Beneficios
        </ButtonFunction>
      </Card>
    </motion.div>
  )
}

export default ManageBenefits